import create from "zustand";
import { produce } from "immer";

interface GrowthReport {
  GrowthReportData: GrowthReportProps;
  handleGrowthReportData: (data: any) => void;
  resetGrowthReport: () => void;
}

const INITIAL_STATE: GrowthReportProps = {
  gender: "",
  age: "",
  age_text: "",

  weight: 0,
  height: 0,
  bmi: 0,

  weight_range: "",
  weight_normal_lower: 0,
  weight_normal_upper: 0,
  z_score_weight: 0,

  height_range: "",
  height_normal_lower: 0,
  height_normal_upper: 0,
  z_score_height: 0,

  bmi_range: "",
  bmi_normal_lower: 0,
  bmi_normal_upper: 0,
  z_score_bmi: 0,

  physical_doctor_no: "",
  physical_doctor_designation: "",
  physical_doctor_hospital: "",
  physical_doctor_path: "",
};

export const useGrowthReport = create<GrowthReport>((set) => ({
  GrowthReportData: INITIAL_STATE,

  handleGrowthReportData: (data) => {
    const responseData = Array.isArray(data) ? data[0] : data;

    if (!responseData || Object.keys(responseData).length === 0) {
      console.warn("Growth Store: Empty data received");
      return;
    }

    set(
      produce((state: GrowthReport) => {
        state.GrowthReportData = {
          ...state.GrowthReportData,
          ...responseData,
        };
      })
    );
  },

  resetGrowthReport: () =>
    set({
      GrowthReportData: {
        ...INITIAL_STATE,
      },
    }),
}));
